/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetGoodsReceivedNoteApprovalDetails,
    UpdateAllGoodsReceivedNoteDetails
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetGoodsReceivedNoteApprovalDetails(operationEntityID, date) {
    const response = await CommonGet('/api/GoodsReceivedNote/GetGoodsReceivedNoteApprovalDetails', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function UpdateAllGoodsReceivedNoteDetails(data) {
    const response = await CommonPost('/api/GoodsReceivedNote/UpdateAllGoodsReceivedNoteDetails', null, data);
    return response;
}